import graphqlClient from '../../api/axios_interceptor';
import { RegisterPushTokenMutation } from '../../api/graphql/queries/notifications';
import {
    REGISTER_PUSH_TOKEN
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

const registerPushTokenMiddleware = async (action) => {
    try {
        const token = action.payload.token;
        const mutation = RegisterPushTokenMutation(token);
        
        await graphqlClient({
            data: {
                query: mutation,
                variables: {
                    devicePushToken: token
                }
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.registerPushToken.success) {
                action.payload = {
                    ...action.payload,
                    success: true,
                    user: queryResult.data.data.registerPushToken.user
                };
            } else {
                const error = queryResult.data.data.registerPushToken.errors || 'Failed to register push token';
                action = updateActionErrors(action, error);
            }
        });
    } catch (error) {
        console.error('Error registering push token:', error);
        action = updateActionErrors(action, error);
    }
    return action;
};

export const notificationsMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case REGISTER_PUSH_TOKEN:
            action = await registerPushTokenMiddleware(action);
            break;
    }
    return next(action);
};
